import { ColDef } from 'ag-grid-community';
import {getFormattedNumber} from '../helpers';

export const defaultValuesColumnOrders: ColDef[] = [
  {headerName: 'ID', field: 'id', enableRowGroup: true, enableValue: true},
  {headerName: 'Номер заявки', field: 'number', enableRowGroup: true, enableValue: true},
  {headerName: 'Статус', field: 'status', enableRowGroup: true, enableValue: true},
  {headerName: 'Способ оплаты', field: 'get_payment_type', enableRowGroup: true, enableValue: true},
  {headerName: 'Тип услуги', field: 'side', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Дата начала сессии',
    type: ['startDateColumn', 'nonEditableColumn'],
    field: 'start_date_at',
    minWidth: 190,
    enableRowGroup: true,
    enableValue: true
  },
  {headerName: 'Время начала сессии', field: 'start_time_at', enableRowGroup: true, enableValue: true},
  {headerName: 'Подбор пары', field: 'is_need_pair', enableRowGroup: true, enableValue: true},
  {headerName: 'Подбор мин.', field: 'fly_session_minutes', enableRowGroup: true, enableValue: true},
  {headerName: 'Тариф мин.', field: 'session_minutes', enableRowGroup: true, enableValue: true},
  {headerName: 'Контрагент', field: 'customer.getFullUsername', enableRowGroup: true, enableValue: true},
  {headerName: 'Тариф', field: 'tariff.title', enableRowGroup: true, enableValue: true},
  {headerName: 'Оплата на месте', field: 'is_pay_here', aggFunc: 'sum', enableRowGroup: true},
  {headerName: 'Стоимость (руб.)', field: 'price', enableRowGroup: true, enableValue: true, aggFunc: 'sum'},
  {headerName: 'Оплачено (руб.)', field: 'price_paid', enableValue: true, aggFunc: 'sum', enableRowGroup: true},
  {headerName: 'Тарифы сеты', field: 'count_party', enableRowGroup: true, enableValue: true},
  {headerName: 'Количество участников', field: 'participant_count', enableRowGroup: true, enableValue: true},
  {headerName: 'Будут дети', field: 'is_children', enableRowGroup: true, enableValue: true},
  {headerName: 'Количество детей', field: 'count_party_children', enableRowGroup: true, enableValue: true},
  {headerName: 'Акция', field: 'stock.title', enableRowGroup: true, enableValue: true},
  {headerName: 'Размер скидки (руб.)', field: 'price_stock', enableRowGroup: true, enableValue: true, aggFunc: 'sum'},
  {headerName: 'Бонусные минуты', field: 'session_minutes_stock', enableRowGroup: true, enableValue: true},
  {headerName: 'Ручная акция', field: 'is_manual_discount', enableRowGroup: true, enableValue: true},
  {headerName: 'Промо код', field: 'promo_code', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Ручная скидка значение',
    field: 'manual_discount',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Оплачено сертификатом',
    field: 'certificate',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.certificate) {
        return `${params.data.certificate.title} (${params.data.certificate.id})`;
      }
      return '-';
    }},
  {headerName: 'Причина отказа', field: 'cancel_reason', enableRowGroup: true, enableValue: true},
  {headerName: 'Комментарий к причине отказа', field: 'cancel_reason_comment', enableRowGroup: true, enableValue: true},
  {headerName: 'Откуда узнали', field: 'source_which', enableRowGroup: true, enableValue: true},
  {headerName: 'Источник заяки', field: 'source', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Дата создания',
    type: ['defaultDateColumn', 'nonEditableColumn'],
    field: 'created_at',
    minWidth: 190,
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Дата изменения',
    type: ['defaultDateColumn', 'nonEditableColumn'],
    field: 'updated_at',
    minWidth: 190,
    enableRowGroup: true,
    enableValue: true
  },
  {headerName: 'Автор(сотрудник)', field: 'user.getFullUsername', enableRowGroup: true, enableValue: true},
  {headerName: 'Почта', field: 'customer.userEmail', enableRowGroup: true, enableValue: true},
  {headerName: 'Телефон', field: 'customer.phoneUser', enableRowGroup: true, enableValue: true},
  {headerName: 'Счет', field: 'payOrder', enableRowGroup: true, enableValue: true},
  {headerName: 'Оплачено ресурсным депозитом', field: 'userDeposit', enableRowGroup: true, enableValue: true},
  {headerName: 'Комментарий к заявке', field: 'comment', enableRowGroup: true, enableValue: true}
];


export const defaultValuesColumnPayments: ColDef[] = [
  {headerName: 'Номер', field: 'id', enableRowGroup: true, enableValue: true},
  {headerName: 'Тип', field: 'getPaymentType', enableRowGroup: true, enableValue: true},
  {headerName: 'Контрагент', field: 'account.customer.getFullUsername', enableRowGroup: true, enableValue: true},
  {headerName: 'Тип контрагента', field: 'account.customer.userType', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Заявки', field: 'account.orderPayOrder', enableRowGroup: true, enableValue: true, valueGetter: (params: any) => {
      if (params.data && params.data.account && params.data.account.orderPayOrder.length > 0) {
        return params.data.account.orderPayOrder.map((val: any) => val.number).join();
      }
      return '-';

    }
  },
  {
    headerName: 'Тип услуги',
    field: 'service_type',
    enableRowGroup: true,
    enableValue: true,
  },
  {headerName: 'Оператор', field: 'operator', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Оказанные услуги', field: 'orderService', enableRowGroup: true, enableValue: true, valueGetter: (params: any) => {
      if (params.data && params.data.orderService && params.data.orderService.length > 0) {
        return params.data.orderService.map((val: any) => val.number).join();
      }
      return '-';

    }
  },
  {headerName: 'Услуга', field: 'getNewService', enableRowGroup: true, enableValue: true},
  {headerName: 'Сумма', field: 'getAmount', enableRowGroup: true, enableValue: true, aggFunc: 'sum', valueFormatter: getFormattedNumber},
  {
    headerName: 'Тариф - тип контрагента', field: 'account.tariffs', enableRowGroup: true, enableValue: true, valueGetter: (params: any) => {
      if (params.data && params.data.account) {
        return params.data.account.tariffs.reduce((val1: any, val2: any) => `${val1} ${val2.title} -  ${val2.userType ? val2.userType : 'Без типа контрагента'},`, '');
      }
      return '-'
    }, filter: 'agTextColumnFilter'
  },
  {headerName: 'Статус', field: 'getStatusValue', enableRowGroup: true, enableValue: true},
  {headerName: 'Статус (счета)', field: 'getStatus', enableRowGroup: true, enableValue: true},
  {headerName: 'Счет', field: 'account.id', filter: 'agNumberColumnFilter', enableRowGroup: true, enableValue: true},
  {headerName: 'Способ оплаты', field: 'getPaymentMethod', enableRowGroup: true, enableValue: true},
  {headerName: 'Деп. руб', field: 'getDepositMoney', allowedAggFuncs: ['sum', 'min', 'max'], enableRowGroup: true, enableValue: true, aggFunc: 'sum', },
  {
    headerName: 'Деп. труба',
    field: 'getDepositMinutesFly',
    allowedAggFuncs: ['sum', 'min', 'max'],
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Деп. волна',
    field: 'getDepositMinutesWave',
    allowedAggFuncs: ['sum', 'min', 'max'],
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {headerName: 'Автор', field: 'account.author.getFullUsername', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Дата создания',
    type: ['startDateColumn', 'nonEditableColumn'],
    field: 'createdAt',
    minWidth: 190,
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Дата обновления',
    type: ['startDateColumn', 'nonEditableColumn'],
    field: 'updatedAt',
    minWidth: 190,
    enableRowGroup: true,
    enableValue: true
  },
  {headerName: 'utm_campaign', field: 'utm_campaign', enableRowGroup: true, enableValue: true},
  {headerName: 'utm_source', field: 'utm_source', enableRowGroup: true, enableValue: true},
  {headerName: 'utm_content', field: 'utm_content', enableRowGroup: true, enableValue: true},
  {headerName: 'utm_medium', field: 'utm_medium', enableRowGroup: true, enableValue: true},
  {headerName: 'utm_term', field: 'utm_term', enableRowGroup: true, enableValue: true},
  {
    headerName: 'Ресурс',
    field: 'unitsAmount',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Оплачено депозитом', field: 'userDeposit', enableRowGroup: true, enableValue: true, aggFunc: 'sum', valueGetter: (params: any) => {
      if (params.data.userDeposit && params.data.userDeposit.title && params.data.userDeposit.id) {
        return `${params.data.userDeposit.title} (${params.data.userDeposit.id})`;
      }
      return '-';
    }
  },
  {
    headerName: 'Куплен депозит', field: 'purchasedUserDeposit', enableValue: true, valueGetter: (params: any) => {
      if (params.data && params.data.purchasedUserDeposit) {
        return params.data.purchasedUserDeposit.title
      }
      return '-';
    }
  },
  {
    headerName: 'Оплачено сертификатом', field: 'certificate', enableRowGroup: true,enableValue: true, aggFunc: 'sum', valueGetter: (params: any) => {
      if (params.data.certificate && params.data.certificate.title && params.data.certificate.id) {
        return `${params.data.certificate.title} (${params.data.certificate.id})`;
      }
      return '-';
    }
  },
  {
    headerName: 'Куплен сертификат', field: 'purchased_certificate',enableRowGroup: true, enableValue: true, valueGetter: (params: any) => {
      if (params.data && params.data.purchased_certificate) {
        return params.data.purchased_certificate.title;
      }
      return '-';
    }
  },
  {
    headerName: 'Ставка денежного депозита', field: 'purchasedMoneyDepositRate',enableValue: true, aggFunc: 'sum', enableRowGroup: true, valueGetter: (params: any) => {
      if (params.data && params.data.purchasedMoneyDepositRate) {
        return params.data.purchasedMoneyDepositRate.title;
      }
      return '-';
    }
  },
  {
    headerName: 'ID депозита',
    field: 'depositGroupId',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.depositGroupId) {
        return params.data.depositGroupId;
      }
      return '-';
    }
  },
  {
    headerName: 'Название депозита',
    field: 'depositGroupName',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.depositGroupName) {
        return params.data.depositGroupName;
      }
      return '-';
    }
  },
  {
    headerName: 'Ресурс (мин/сеты) депозита',
    field: 'depositGroupResource',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.depositGroupResource) {
        return params.data.depositGroupResource;
      }
      return '-';
    }
  },
  {
    headerName: 'Кол-во сетов, сертификат',
    field: 'certificateGroupWaveSets',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.certificateGroupWaveSets) {
        return params.data.certificateGroupWaveSets;
      }
      return '-';
    }
  },
  {
    headerName: 'Кол-во минут трубы, сертификат',
    field: 'certificateGroupFlyMinutes',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.certificateGroupFlyMinutes) {
        return params.data.certificateGroupFlyMinutes;
      }
      return '-';
    }
  },
  {
    headerName: 'Название сертификатов',
    field: 'certificateGroupName',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.certificateGroupName) {
        return params.data.certificateGroupName;
      }
      return '-';
    }
  },
  {
    headerName: 'Примечание сертификатов',
    field: 'certificateGroupDescription',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.certificateGroupDescription) {
        return params.data.certificateGroupDescription;
      }
      return '-';
    }
  },
  {
    headerName: ' Номер и серия сертификатов',
    field: 'certificateNumberSeries',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data && params.data.certificateSeries && params.data.certificateNumber) {
        return `${params.data.certificateNumber} - ${params.data.certificateSeries}`;}
      if (params.data && !params.data.certificateSeries && params.data.certificateNumber){
        return params.data.certificateNumber;}
      return '-';
    }
  },
  {
    headerName: 'Примечание платежа',
    field: 'comment',
    enableRowGroup: true,
    enableValue: true
  },
]

export const defaultValuesColumnInvoices: ColDef[] = [
  {
    headerName: 'ID',
    field: 'id',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Сумма',
    field: 'amount',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum',
    valueFormatter: getFormattedNumber,
  },
  {
    headerName: 'Стоимость в ресурсах',
    field: 'get_amount_min',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum',
    valueFormatter: getFormattedNumber,
  },
  {
    headerName: 'Оплачено',
    field: 'price_paid',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum',
    valueFormatter: getFormattedNumber,
  },
  {
    headerName: 'Оплачено депозитом (ресурс)',
    field: 'deposit_units_paid',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum',
    valueFormatter: getFormattedNumber,
  },
  {
    headerName: 'Оплачено сертификатом (ресурс)',
    field: 'certificate_units_paid',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum',
    valueFormatter: getFormattedNumber,
  },
  {
    headerName: 'Статус',
    field: 'status',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Автор (сотрудник)',
    field: 'author',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Контрагент (плательщик)',
    field: 'customer',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Оператор СРК',
    field: 'operator',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Услуга',
    field: 'service',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Тип услуги',
    field: 'side',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Дата и время создания',
    field: 'created_at',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Дата и время изменения',
    field: 'updated_at',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Массовое бронирование',
    field: 'is_mass_booking',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data) {
        return params.data.is_mass_booking ? 'Да' : 'Нет';
      }
      return '-';
    }
  },
  {
    headerName: 'Оплата на месте',
    field: 'is_pay_here',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data) {
        return params.data.is_pay_here ? 'Да' : 'Нет';
      }
      return '-';
    }
  },
  {
    headerName: 'Тип счета',
    field: 'pay_type',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Способ оплаты',
    field: 'payment_method',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Ссылка для онлайн оплаты',
    field: 'payment_url',
    enableRowGroup: true,
    enableValue: true,
    valueGetter: (params: any) => {
      if (params.data) {
        return params.data.payment_url ?? '-';
      }
      return '-';
    }
  },
  {
    headerName: 'Id заявок',
    field: 'orders',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Приобретен сертификат',
    field: 'purchased_certificate',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Минуты сертификата',
    field: 'mins_cert',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Сеты сертификата',
    field: 'sets_cert',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Приобретен депозит',
    field: 'purchased_deposit',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Минуты депозита',
    field: 'mins_deposit',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Сеты депозита',
    field: 'sets_deposit',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  {
    headerName: 'Денежный депозит (руб.)',
    field: 'money_deposit',
    enableRowGroup: true,
    enableValue: true,
    aggFunc: 'sum'
  },
  { headerName: 'utm_campaign', field: 'utm_campaign', enableRowGroup: true, enableValue: true },
  { headerName: 'utm_source', field: 'utm_source', enableRowGroup: true, enableValue: true },
  { headerName: 'utm_content', field: 'utm_content', enableRowGroup: true, enableValue: true },
  { headerName: 'utm_medium', field: 'utm_medium', enableRowGroup: true, enableValue: true },
  { headerName: 'utm_term', field: 'utm_term', enableRowGroup: true, enableValue: true },
  {
    headerName: 'Тип контрагента труба',
    field: 'customer__tube_user_type__title',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Тип контрагента волна',
    field: 'customer__wave_user_type__title',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Информация о покупке',
    field: 'purchase_info',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Название сертификатов',
    field: 'certificate_group_name',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Кол-во услуг',
    field: 'certificate_group_count',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Название депозитов',
    field: 'deposit_group_name',
    enableRowGroup: true,
    enableValue: true
  },
  {
    headerName: 'Аренды Сертификата',
    field: 'certificate_rent_pay_count',
    enableRowGroup: true,
    enableValue: true
  }
]

export const AG_GRID_LOCALE_RU = {
  // Выбор фильтра
  selectAll: '(Выделить все)',
  selectAllSearchResults: '(Выделить все результаты поиска)',
  searchOoo: 'Поиск...',
  blanks: '(Пусто)',
  noMatches: 'Нет совпадений',

  // Числовой фильтр & текстовый фильтр
  filterOoo: 'Фильтрация...',
  equals: 'Равно',
  notEqual: 'Не равно',
  empty: 'Выберите один',

  // Числовой фильтр
  lessThan: 'Меньше, чем',
  greaterThan: 'Больше, чем',
  lessThanOrEqual: 'Меньше или равно',
  greaterThanOrEqual: 'Больше или равно',
  inRange: 'В промежутке',
  inRangeStart: 'от',
  inRangeEnd: 'до',

  // Текстовый фильтр
  contains: 'Содержит',
  notContains: 'Не содержит',
  startsWith: 'Начинается с',
  endsWith: 'Кончается на',

  // Фильтр даты
  dateFormatOoo: 'dd-mm-yyyy',

  // Условия фильтрации
  andCondition: 'И',
  orCondition: 'ИЛИ',

  // Кнопки фильтра
  applyFilter: 'Применить',
  resetFilter: 'Сбросить',
  clearFilter: 'Очистить',
  cancelFilter: 'Отменить',

  // Заголовки фильтра
  textFilter: 'Текстовый фильтр',
  numberFilter: 'Числовой фильтр',
  dateFilter: 'Фильтр по дате',
  setFilter: 'Выбрать фильтр',

  // Боковая панель
  columns: 'Столбцы',
  filters: 'Фильтры',

  // Панель инструментов столбцов
  pivotMode: 'Режим сводной таблицы',
  groups: 'Группы строк',
  rowGroupColumnsEmptyMessage: 'Перетащите сюда для группировки по строкам',
  values: 'Значения',
  valueColumnsEmptyMessage: 'Перетащите сюда для агрегации',
  pivots: 'Заголовки столбцов',
  pivotColumnsEmptyMessage: 'Перетащите сюда для задания заголовков столбцам',

  // Заголовок группы столбцов по умолчанию
  group: 'Группа',

  // Другое
  loadingOoo: 'Загрузка...',
  noRowsToShow: 'Нет данных. Укажите другой диапазон',
  enabled: 'Включено',

  // Меню
  pinColumn: 'Закрепить столбец',
  pinLeft: 'Закрепить слева',
  pinRight: 'Закрепить справа',
  noPin: 'Не закреплять',
  valueAggregation: 'Агрегация по значению',
  autosizeThiscolumn: 'Автоматически задавать размер этого столбца',
  autosizeAllColumns: 'Автоматически задавать размер всем столбцам',
  groupBy: 'Группировать по',
  ungroupBy: 'Разгруппировать по',
  resetColumns: 'Сбросить столбцы',
  expandAll: 'Развернуть все',
  collapseAll: 'Свернуть все',
  copy: 'Копировать',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Копировать с заголовками',
  paste: 'Вставить',
  ctrlV: 'Ctrl+V',
  export: 'Экспорт',
  csvExport: 'Экспорт в CSV (.csv)',
  excelExport: 'Экспорт в Excel (.xlsx)',
  excelXmlExport: 'Экспорт в XML (.xml)',

  // Агрегирование корпоративного меню и строки состояния
  sum: 'Сумма ',
  min: 'Минимум ',
  max: 'Максимум ',
  none: 'Пусто',
  count: 'Количество',
  avg: 'Среднее значение',
  filteredRows: 'Отфильтровано',
  selectedRows: 'Выбрано',
  totalRows: 'Всего строк',
  totalAndFilteredRows: 'Строки',
  more: 'многих',
  to: 'из',
  of: 'по',
  page: 'Страница',
  nextPage: 'Следующая страница',
  lastPage: 'Последняя страница',
  firstPage: 'Первая страница',
  previousPage: 'Предыдущая страница',

  // Корпоративное меню (графики)
  pivotChartAndPivotMode: 'Сводная диаграмма & режим сведения',
  pivotChart: 'Сводная диаграмма',
  chartRange: 'Диапазон диаграммы',

  columnChart: 'Столбиковая диаграмма',
  groupedColumn: 'Сгруппированная',
  stackedColumn: 'Сложенная',
  normalizedColumn: '100% Сложенная',

  barChart: 'Панель',
  groupedBar: 'Сгруппированная',
  stackedBar: 'Сложенная',
  normalizedBar: '100% Сложенная',

  pieChart: 'Круговая диаграмма',
  pie: 'Круговая диаграмма',
  doughnut: 'Кольцевая диаграмма',

  line: 'Линия',

  xyChart: 'X Y (Разброс)',
  scatter: 'Диаграмма рассеяния',
  bubble: 'Пузырьковая диаграмма',

  areaChart: 'Область',
  area: 'Диаграмма с областями',
  stackedArea: 'Сложенная',
  normalizedArea: '100% Сложенная',

  histogramChart: 'Гистограмма',

  // Графики
  pivotChartTitle: 'Сводная диаграмма',
  rangeChartTitle: 'График диапазона',
  settings: 'Настройки',
  data: 'Данные',
  format: 'Формат',
  categories: 'Категории',
  defaultCategory: '(Пусто)',
  series: 'Серии',
  xyValues: 'X Y Значения',
  paired: 'Парный режим',
  axis: 'Ось',
  navigator: 'Навигация',
  color: 'Цвет',
  thickness: 'Толщина',
  xType: 'X Тип',
  automatic: 'Автоматически',
  category: 'Категория',
  number: 'Число',
  time: 'Время',
  xRotation: 'X Поворот',
  yRotation: 'Y Поворот',
  ticks: 'Отметки',
  width: 'Ширина',
  height: 'Высота',
  length: 'Длина',
  padding: 'Внутренний отступ',
  spacing: 'Отступ',
  chart: 'Диаграмма',
  title: 'Заголовок',
  titlePlaceholder: 'Заголовок диаграммы - двойной щелчок для редактирования',
  background: 'Фон',
  font: 'Шрифт',
  top: 'Верх',
  right: 'Право',
  bottom: 'Низ',
  left: 'Лево',
  labels: 'Метки',
  size: 'Размер',
  minSize: 'Минимальный размер',
  maxSize: 'Максимальный размер',
  legend: 'Легенда',
  position: 'Позиция',
  markerSize: 'Размер маркера',
  markerStroke: 'Обводка маркера',
  markerPadding: 'Внутренний отступ маркера',
  itemSpacing: 'Расстояние между предметами',
  itemPaddingX: 'Внутренний отступ предмета по X',
  itemPaddingY: 'Внутренний отступ предмета по Y',
  layoutHorizontalSpacing: 'Горизонтальный отступ',
  layoutVerticalSpacing: 'Вертикальный отступ',
  strokeWidth: 'Ширина обводки',
  offset: 'Смещение',
  offsets: 'Смещения',
  tooltips: 'Всплывающие подсказки',
  callout: 'Вызов',
  markers: 'Маркеры',
  shadow: 'Тень',
  blur: 'Размытие',
  xOffset: 'Смещение по X',
  yOffset: 'Смещение по Y',
  lineWidth: 'Ширина линии',
  normal: 'Нормальный',
  bold: 'Жирный',
  italic: 'Наклоненный',
  boldItalic: 'Жирный наклоненный',
  predefined: 'Предопределенный',
  fillOpacity: 'Непрозрачность заливки',
  strokeOpacity: 'Непрозрачность линии',
  histogramBinCount: 'Количество сегментов',
  columnGroup: 'Столбец',
  barGroup: 'Панель',
  pieGroup: 'Круговая',
  lineGroup: 'Линейная',
  scatterGroup: 'X Y (Разброс)',
  areaGroup: 'Зональная',
  histogramGroup: 'Гистограмма',
  groupedColumnTooltip: 'Сгруппированная',
  stackedColumnTooltip: 'Сложенная',
  normalizedColumnTooltip: '100% Сложенная',
  groupedBarTooltip: 'Сгруппированная',
  stackedBarTooltip: 'Сложенная',
  normalizedBarTooltip: '100% Сложенная',
  pieTooltip: 'Круговая',
  doughnutTooltip: 'Кольцевая',
  lineTooltip: 'Линейная',
  groupedAreaTooltip: 'Зональная',
  stackedAreaTooltip: 'Сложенная',
  normalizedAreaTooltip: '100% Сложенная',
  scatterTooltip: 'Рассеяния',
  bubbleTooltip: 'Пузырьковая',
  histogramTooltip: 'Гистограмма',
  noDataToChart: 'Нет данных для представления в виде диаграммы.',
  pivotChartRequiresPivotMode: 'Для сводной диаграммы необходимо включить режим сводной диаграммы.',
  chartSettingsToolbarTooltip: 'Меню',
  chartLinkToolbarTooltip: 'Связать с сеткой',
  chartUnlinkToolbarTooltip: 'Не связывать с сеткой',
  chartDownloadToolbarTooltip: 'Загрузить диаграмму',

  // ARIA
  ariaHidden: 'скрытый',
  ariaVisible: 'видимый',
  ariaChecked: 'проверенный',
  ariaUnchecked: 'непроверенный',
  ariaIndeterminate: 'неопределенный',
  ariaColumnSelectAll: 'Переключить на выделение всех столбцов',
  ariaInputEditor: 'Редактор ввода',
  ariaDateFilterInput: 'Ввод фильтра даты',
  ariaFilterInput: 'Ввод фильтра',
  ariaFilterColumnsInput: 'Ввод фильтра столбцов',
  ariaFilterValue: 'Значение фильтра',
  ariaFilterFromValue: 'Фильтровать от значения',
  ariaFilterToValue: 'Фильтровать до значения',
  ariaFilteringOperator: 'Оператор фильтрации',
  ariaColumnToggleVisibility: 'переключить видимость столбца',
  ariaColumnGroupToggleVisibility: 'переключить видимость группы столбцов',
  ariaRowSelect: 'Нажмите ПРОБЕЛ для выделения данной строки',
  ariaRowDeselect: 'Нажмите ПРОБЕЛ для снятия выделения данной строки',
  ariaRowToggleSelection: 'Нажмите ПРОБЕЛ, чтобы переключить выделение строки',
  ariaRowSelectAll: 'Нажмите ПРОБЕЛ, чтобы переключить выделение всех строк',
  ariaSearch: 'Поиск',
  ariaSearchFilterValues: 'Поиск значений по фильтру'
};

export enum STATISTICS_TAB {
  ORDERS = 'orders',
  PAYMENTS = 'payments',
  INVOICES = 'invoices'
}

export enum REPORT_STATUS {
  NOT_REQUESTED = 'not requested',
  FORMING = 'report prepare',
  READY = 'report ready'
}